import { LinearProgress } from "@mui/material";
import { Navigate } from "react-router-dom";
import { useSession } from "src/context/SessionProvider";

interface Props {
  children: React.ReactNode;
}

const PublicRoute = ({ children }: Props) => {
  const { session, loading } = useSession();

  if (loading) {
    return <LinearProgress />;
  }

  if (session) {
    return <Navigate to={"/auth-queue"} replace />;
  }

  return children;
};

export default PublicRoute;
